import React, { useEffect } from "react";
import { RootState } from "../store/store";
import { useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom';
import { LoadingDialog } from "../components/HelperComponents/LoadingDialog";
import { RoleEnum } from "../types/enums";

/**
 * @remarks Redirect page to redirect users to the appropriate dashboard page based
 * on the user's role Id. (Youth Dashboard, School Coordinator Dashboard, and Admin Dashboard.)
 * @returns nothing this page is only for redirecting users.
 */
export function RedirectToDash() {
    const navigate = useNavigate();
    const user = useSelector((state: RootState) => state.userDetail);

    useEffect(() => {
        if (user.roleId === RoleEnum.Youth) {
            navigate(`/youthdashboard`)
        }
        else if (user.roleId === RoleEnum.SchoolCoordinator) {
            navigate(`/schoolcoordinatordashboard`)
        }
        else if (user.roleId > 0 && user.roleId < RoleEnum.SchoolCoordinator) {
            navigate(`/admindashboard`)
        }
    }, [user])

    return (
        <div>
            <LoadingDialog loading={true} />
        </div>)
}
